<template>
  <v-container fluid>
    <v-data-table
      dense
      v-model="campusGroupAdminsSelected"
      :headers="headers"
      :items="items"
      :single-select="singleSelect"
      item-key="id"
      :loading="tableLoading"
      show-select
      class="elevation-0"
      checkbox-color="deep-purple"
      hide-default-footer
    >
      <template v-slot:item.campusGroup="{ item }">
        <div v-if="item.campusGroup" class="d-flex justify-start align-center">
          <img v-if="item.country"
            :src="`${flagsPath}${item.country.iso_code}.png`"
            alt="country flag"
            width="35vh"
            height="25vh"
            class="mr-2"
          />
          <span>{{item.campusGroup.name}}</span>
        </div>
      </template>
      <template v-slot:item.fullName="{ item }">
        <span class="font-weight-bold">
          {{ item.firstname }} {{ item.lastname }} {{ item.lastname2nd }}
        </span>
      </template>
      <template v-slot:item.district="{ item }">
        <span v-if="item.campusGroup && item.campusGroup.schoolGroup">
          {{ item.campusGroup.schoolGroup.name }}
        </span>
        <span v-else class="grey--text">N/A</span>
      </template>
      <template v-slot:item.register_date="{ item }">
        <span v-if="item.creationDate" class="font-weight-bold">
          {{ item.creationDate | moment('MM/D/YYYY') }}
        </span>
        <span v-else class="orange--text darken-2 font-weight-bold">Vacio</span>
      </template>
      <template v-slot:item.state="{ item }">
        <span v-if="item.active"
              class="green--text font-weight-bold">{{ $t('students.active')}}</span>
        <span v-else
              class="orange--text darken-2 font-weight-bold">{{ $t('students.inactive')}}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row justify="center" align="center" no-gutters>
          <v-col cols="auto">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="info"
                  @click="editCampusGroupAdmin(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <!-- Toolbar para acciones múltiples -->
    <v-toolbar
      v-if="campusGroupAdminsSelected.length > 0"
      dense
      flat
      color="grey lighten-3"
      class="mt-2"
    >
      <v-toolbar-title class="subtitle-2">
        {{ campusGroupAdminsSelected.length }}
        {{
          campusGroupAdminsSelected.length === 1
            ? 'administrador seleccionado'
            : 'administradores seleccionados'
        }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="red"
        outlined
        small
        @click="deleteSelected"
        :loading="deleteLoading"
        :disabled="deleteLoading"
      >
        <v-icon left small>mdi-delete</v-icon>
        Eliminar seleccionados
      </v-btn>
    </v-toolbar>

    <div class="text-center pt-2">
      <v-pagination
        @input="setValue($event)"
        v-model="page"
        :length="length"
        :total-visible="6"
        color="deep-purple lighten-3"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
import { FLAGS_URL } from '../../constants/data';
import LoadingMixin from '../../mixins/loading';
import snackbarMixin from '../../mixins/snackbar';
import campusGroupAdminService from '../../services/campusGroupAdmin.service';

export default {
  props: {
    items: { type: Array, default: () => ([]) },
    page: { type: Number, default: 1 },
    length: { type: Number, default: 1 },
    tableLoading: { type: Boolean, default: false },
  },
  data: () => ({
    singleSelect: false,
    campusGroupAdminsSelected: [],
    flagsPath: FLAGS_URL,
    deleteLoading: false,
    headers: [
      {
        text: 'Nombre Completo',
        align: 'start',
        sortable: false,
        value: 'fullName',
      },
      { text: 'Email', value: 'email' },
      { text: 'DNI', value: 'dni' },
      { text: 'Grupo de Sede', value: 'campusGroup' },
      { text: 'Distrito', value: 'district' },
      { text: 'Fecha de registro', value: 'register_date' },
      { text: 'Estado', value: 'state' },
      {
        text: 'Acciones', value: 'actions', sortable: false, align: 'center',
      },
    ],
  }),
  mixins: [LoadingMixin, snackbarMixin],
  methods: {
    setValue(page) {
      this.$emit('input', page);
    },
    editCampusGroupAdmin(campusGroupAdmin) {
      this.$emit('edit', campusGroupAdmin);
    },
    async deleteSelected() {
      this.deleteLoading = true;
      try {
        const ids = this.campusGroupAdminsSelected.map((admin) => admin.id);
        await campusGroupAdminService.deleteMultipleCampusGroupAdmins(ids);

        this.snackbarSuccess(
          `Se eliminaron ${ids.length} administradores correctamente`,
        );
        this.campusGroupAdminsSelected = [];
        this.$emit('refresh');
      } catch (error) {
        const errorMessage = this.getErrorMessage(error);
        this.snackbarError(errorMessage);
      } finally {
        this.deleteLoading = false;
      }
    },
    getErrorMessage(error) {
      const data = error.response?.data;
      return data?.message || data?.title || error.message || 'Error al eliminar administradores';
    },
  },
  watch: {
    campusGroupAdminsSelected(newVal) {
      this.$emit('selected', newVal);
    },
  },
};
</script>
